import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Notifications() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!window.app.isElectron || !window.desktopIntegrations?.onNotificationHandler) {
      return () => null;
    }

    const unregister = window.desktopIntegrations.onNotificationHandler((data) => {
      if (data.data.contactID) {
        navigate(`/contact/${data.data.contactID}`);
      }
    });

    return () => unregister();
  }, []);

  return null;
}
